import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-5huya4-0"
})(["display:grid;grid-template-columns:repeat(", ",minmax(220px,1fr));column-gap:", ";row-gap:", ";", ""], ({
  $numColumns
}) => typeof $numColumns === 'number' ? $numColumns : 'auto-fit', ({
  theme
}) => theme.spacing.base.default, ({
  theme
}) => theme.spacing.small.default, isMobile(css(["display:flex;flex-direction:column;grid-template-columns:none;"])));
const Fieldset = /*#__PURE__*/styled('fieldset').withConfig({
  componentId: "sc-storm-ui-40025937__sc-5huya4-1"
})(["border:none;margin:0;padding:0;"]);
const MessageWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-5huya4-2"
})(["padding-inline:", ";padding-block:", ";", ""], ({
  theme
}) => theme.spacing.none.default, ({
  theme
}) => theme.spacing.base.default, isMobile(css(["position:sticky;bottom:0;background-color:", ";"], ({
  theme
}) => theme.selectableContainer.backgroundColor.default)));

export { Container as C, Fieldset as F, MessageWrapper as M };
//# sourceMappingURL=TileGroup.styles-BXHtPMdZ.js.map
